import type { IconGlyph } from '../icon';

/**
 * Tractie `eye` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1, `dist/jsx/m/eye.jsx`. Older than the
 * v1.5.0 of `star.ts`, same shape as the eye in the Figma design.
 */
export const iconEye: IconGlyph = {
  name: 'eye',
  path: [
    'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4m0 7c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3',
    'M12 5C6.48 5 2 11 2 12s4.48 7 10 7 10-6 10-7-4.48-7-10-7m8.4 7.93c-.46.64-1.15 1.43-2 2.2-1.73 1.55-4 2.87-6.4 2.87s-4.68-1.32-6.4-2.87c-.85-.76-1.54-1.55-2-2.2-.23-.32-.4-.6-.5-.8a.7.7 0 0 1-.06-.13c.02-.04.04-.08.06-.13.1-.2.27-.48.5-.8.46-.64 1.15-1.43 2-2.2C7.33 7.32 9.6 6 12 6s4.68 1.32 6.4 2.87c.85.76 1.54 1.55 2 2.2.23.32.4.6.5.8.03.05.05.1.06.13-.02.04-.04.08-.06.13-.1.2-.27.48-.5.8',
  ],
};
